/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na zaznamenávače výjimek pro Sentry API.
 */
class SentryLoggerFactory {
  /**
   * Vytvoří instanci.
   * @param {SentryBrowser} Sentry
   * @param {Class.<SentryLogger>} SentryLogger
   * @param {ErrorLevel} captureErrorLevel Úroveň důležitosti chyby,
   * od které se začínají odesílat události na Sentry.
   * @param {ErrorLevelFactory} errorLevelFactory
   * @param {SentryOfflineIntegration} offlineIntegration
   * @param {SentrySeverityFactory} severityFactory
   * @param {SentryVueIntegration} vueIntegration
   */
  constructor(
    Sentry,
    SentryLogger,
    captureErrorLevel,
    errorLevelFactory,
    offlineIntegration,
    severityFactory,
    vueIntegration
  ) {
    this.Sentry = Sentry;
    this.SentryLogger = SentryLogger;
    this.captureErrorLevel = captureErrorLevel;
    this.errorLevelFactory = errorLevelFactory;
    this.offlineIntegration = offlineIntegration;
    this.severityFactory = severityFactory;
    this.vueIntegration = vueIntegration;
  }

  /**
   * Vytvoří nový zaznamenávač výjimek.
   * @param {string} dsn Sentry DSN adresa k odesílání záznamů.
   * @returns {SentryLogger}
   */
  create(dsn) {
    return new this.SentryLogger(
      this.Sentry,
      this.captureErrorLevel,
      dsn,
      this.errorLevelFactory,
      this.offlineIntegration,
      this.severityFactory,
      this.vueIntegration
    );
  }
}

export default SentryLoggerFactory;
